import debounce from 'lodash/debounce'
import { connect } from 'react-redux'
import { compose, withProps, withHandlers, withState, lifecycle } from 'recompose'
import OTDPAddons from './OTDPAddons'
import { getInitialValues, getMandatoryValues, createAddonsData } from './helpers'
import { updateProductOTDPAddons } from './actions'
import { MODEL_SYNC_DEBOUNCE } from './constants'

const withProductAddonsHandlers = withHandlers(({ changeValue }) => {
  const debouncedChangeValue = debounce(changeValue, MODEL_SYNC_DEBOUNCE)

  return {
    handleChangeValue: () => value =>
      debouncedChangeValue(value),

    handleChange: ({
      value,
      quantity,
      commerceItemId,
      mandatoryValues,
      updateProductOTDPAddons
    }) => (checkboxValue, checked) => {
      const newValue =
        checked ? [...value, checkboxValue] :
          mandatoryValues.includes(checkboxValue) ? value :
            value.filter(value => value !== checkboxValue)

      if (value !== newValue) {
        changeValue(newValue)
        debouncedChangeValue.cancel()

        updateProductOTDPAddons({
          commerceItemId,
          quantity,
          otdpItemId: checkboxValue,
          addAddOnToQuote: checked
        })
      }
    }
  }
})

const withCheckboxListProps = withProps(({ otdpAddons, enableEdit }) => ({
  mandatoryValues: getMandatoryValues(otdpAddons),
  mandatoryItems: createAddonsData(otdpAddons.filter(({ isMandatory }) => isMandatory)),
  optionalItems: createAddonsData(otdpAddons.filter(({ isMandatory, isSelected }) =>
    !isMandatory && (enableEdit || isSelected)))
}))

const withOTDPAddonsStateHandlers = withState(
  'value',
  'changeValue',
  ({ otdpAddons }) => getInitialValues(otdpAddons)
)

const withUpdateValue = lifecycle({
  componentDidUpdate({ otdpAddons }) {
    if (this.props.otdpAddons !== otdpAddons) {
      this.props.handleChangeValue(getInitialValues(this.props.otdpAddons))
    }
  }
})

export default compose(
  connect(null, { updateProductOTDPAddons }),
  withOTDPAddonsStateHandlers,
  withCheckboxListProps,
  withProductAddonsHandlers,
  withUpdateValue
)(OTDPAddons)
